import { useState } from "react";
import { Footer } from "../Footer/Footer";
import { MobileHeader } from "../Header/MobileHeader";
import { maxMobileScreenWidth } from "../../services/constants";
import { DesktopHeader } from "../Header/DesktopHeader";
import "./Wrapper.scss";
import { HeaderTopBar } from "../Header/HeaderTopBar";
import useAsyncEffect from "use-async-effect";
import { ErrorBoundary } from "@sentry/react";
import ErrorFallback from "../App/ErrorFallback";
import { useResizeDetector } from "react-resize-detector";

export const Wrapper = (props) => {
  const { width } = useResizeDetector();
  const [isMobile, setIsMobile] = useState(null);

  useAsyncEffect(async () => {
    window.innerWidth < maxMobileScreenWidth
      ? setIsMobile(true)
      : setIsMobile(false);
  }, [width]);

  return (
    <div className="wrapper-container">
      {!isMobile && <HeaderTopBar />}
      <div className="header-content-wrapper">
        {isMobile ? <MobileHeader /> : <DesktopHeader />}
        <div className="content-wrapper">
          <ErrorBoundary fallback={ErrorFallback}>
            <div className="background-wrapper">{props.children}</div>
          </ErrorBoundary>
          <div style={{ display: "block" }}>
            <Footer />
          </div>
        </div>
      </div>
    </div>
  );
};
